import { configureStore } from '@reduxjs/toolkit';
import defautRetaierIdReducer from './common/defautRetaierId';
import loadingMaskReducer from './common/loadingCount';

import isLoginReducer from './common/login';
import menuIsOpenReducer from './common/menuDropback';
import userInfoReducer from './common/userInfo';

export const store = configureStore({
  reducer: {
    loadingMaskReducer,
    isLoginReducer,
    userInfoReducer,
    // header的menu縮放按鈕影響menu元件的Dropback
    menuDropbackReducer: menuIsOpenReducer,
    defautRetaierIdReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
